"use strict";
/**
 * R10 (addendum §3): the Debt Eliminator design's words (Plan Page ·
 * DebtEliminator.dc.html), for the page with the redesign switch on, on both apps
 * (rule 17). Every figure comes from `/api/plan/debt/` (Plan's engine); helpers take
 * preformatted money and dates ("$300", "Dec 2028"), as Plan's copy does.
 *
 * C1 (Paul's default): the page title is "Debt Eliminator" with the kicker "Plan", and
 * its bucket sentences say "Debt payoff bucket" (the board says "Debt Eliminator bucket").
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_CHART_MINIMUMS_COPY = exports.DEBT_CHART_PLAN_COPY = exports.DEBT_CHART_HEADING_COPY = exports.DEBT_NEXT_TAG_COPY = exports.DEBT_LIST_ROLL_NOTE_COPY = exports.DEBT_LIST_HEADING_COPY = exports.DEBT_EXTRA_SHARED_NOTE_COPY = exports.DEBT_EXTRA_HEADING_COPY = exports.DEBT_EXTRA_PRESETS = exports.DEBT_ORDER_SAVES_COPY = exports.DEBT_ORDER_OPTIONS_COPY = exports.DEBT_ORDER_HEADING_COPY = exports.DEBT_VS_MINIMUMS_COPY = exports.DEBT_INTEREST_SAVED_COPY = exports.DEBT_EXTRA_FROM_BUCKET_COPY = exports.DEBT_EXTRA_EACH_PAYDAY_COPY = exports.DEBT_IN_YOUR_PLAN_COPY = exports.DEBT_FREE_BY_COPY = exports.DEBT_PAYOFF_PLAN_LABEL_COPY = exports.DEBT_ELIMINATOR_HOW_IT_WORKS_COPY = exports.DEBT_ELIMINATOR_SUBTITLE_COPY = exports.DEBT_ELIMINATOR_TITLE_COPY = exports.DEBT_ELIMINATOR_KICKER_COPY = void 0;
exports.debtMinimumsOnlyDateCopy = debtMinimumsOnlyDateCopy;
exports.debtCountCopy = debtCountCopy;
exports.debtFirstPaidOffCopy = debtFirstPaidOffCopy;
exports.debtSoonerCopy = debtSoonerCopy;
exports.debtExtraNoteCopy = debtExtraNoteCopy;
exports.debtPayingFirstTagCopy = debtPayingFirstTagCopy;
exports.debtRowMetaCopy = debtRowMetaCopy;
exports.debtPaidOffOnCopy = debtPaidOffOnCopy;
exports.debtChartEndCopy = debtChartEndCopy;
exports.debtChartLabelCopy = debtChartLabelCopy;
exports.DEBT_ELIMINATOR_KICKER_COPY = "Plan";
exports.DEBT_ELIMINATOR_TITLE_COPY = "Debt Eliminator";
exports.DEBT_ELIMINATOR_SUBTITLE_COPY = "Built from your 12-month analysis. Pick an order, set your extra, see your debt-free date.";
exports.DEBT_ELIMINATOR_HOW_IT_WORKS_COPY = "How Debt Eliminator works";
/** "Your payoff plan": the four tiles. */
exports.DEBT_PAYOFF_PLAN_LABEL_COPY = "Your payoff plan";
exports.DEBT_FREE_BY_COPY = "Debt-free by";
exports.DEBT_IN_YOUR_PLAN_COPY = "In your plan";
exports.DEBT_EXTRA_EACH_PAYDAY_COPY = "Extra each payday";
exports.DEBT_EXTRA_FROM_BUCKET_COPY = "from your Debt payoff bucket";
exports.DEBT_INTEREST_SAVED_COPY = "Interest saved";
exports.DEBT_VS_MINIMUMS_COPY = "vs. minimums only";
/** "Minimums only: Jul 2030" */
function debtMinimumsOnlyDateCopy(date) {
    return `Minimums only: ${date}`;
}
/** "4 debts", "1 debt" */
function debtCountCopy(n) {
    return `${n} ${n === 1 ? "debt" : "debts"}`;
}
/** "Pay down in this order": the two cards of the radiogroup. */
exports.DEBT_ORDER_HEADING_COPY = "Pay down in this order";
exports.DEBT_ORDER_OPTIONS_COPY = {
    avalanche: {
        label: "Highest rate first",
        description: "Saves the most interest",
    },
    snowball: {
        label: "Smallest balance first",
        description: "Quickest first win",
    },
};
/** Before the amount, which is bold: "Saves **$2,773**". */
exports.DEBT_ORDER_SAVES_COPY = "Saves";
/** "First one paid off Mar 2027" */
function debtFirstPaidOffCopy(date) {
    return `First one paid off ${date}`;
}
/** "Extra each payday": C3's presets. A stored amount that is none of them shows as a
 *  selected fourth option, never changed silently. */
exports.DEBT_EXTRA_PRESETS = [150, 300, 450];
exports.DEBT_EXTRA_HEADING_COPY = exports.DEBT_EXTRA_EACH_PAYDAY_COPY;
exports.DEBT_EXTRA_SHARED_NOTE_COPY = "This is your Debt payoff bucket on Plan. Changing it here changes it there, and Home updates right away.";
/** "1 year", "1 year and 7 months", "2 years", "7 months" (the note's gap). */
function debtSoonerCopy(months) {
    const years = Math.floor(months / 12);
    const rest = months % 12;
    const y = years > 0 ? `${years} ${years === 1 ? "year" : "years"}` : "";
    const m = rest > 0 ? `${rest} ${rest === 1 ? "month" : "months"}` : "";
    return y && m ? `${y} and ${m}` : y || m;
}
/**
 * "$300 each payday is about $650 a month on top of your minimums. You’re debt-free Dec
 * 2028, 1 year and 7 months sooner than with minimums only." The second sentence needs a
 * debt-free date, and its gap only when the plan is sooner than minimums only.
 */
function debtExtraNoteCopy(p) {
    const first = `${p.extra} each payday is about ${p.monthly} a month on top of your minimums.`;
    if (p.debtFree === null)
        return first;
    if (p.monthsSooner === null || p.monthsSooner <= 0) {
        return `${first} You’re debt-free ${p.debtFree}.`;
    }
    return `${first} You’re debt-free ${p.debtFree}, ${debtSoonerCopy(p.monthsSooner)} sooner than with minimums only.`;
}
/** "Your debts, in payoff order". */
exports.DEBT_LIST_HEADING_COPY = "Your debts, in payoff order";
exports.DEBT_LIST_ROLL_NOTE_COPY = "When one is paid off, its minimum and extra roll to the next.";
exports.DEBT_NEXT_TAG_COPY = "Next";
/** "Paying first · min + $300 extra" */
function debtPayingFirstTagCopy(extra) {
    return `Paying first · min + ${extra} extra`;
}
/** "27.9% APR · minimum $145" */
function debtRowMetaCopy(apr, minimum) {
    return `${apr} APR · minimum ${minimum}`;
}
/** "Paid off Mar 2027" */
function debtPaidOffOnCopy(date) {
    return `Paid off ${date}`;
}
/** "Your balance over time". */
exports.DEBT_CHART_HEADING_COPY = "Your balance over time";
exports.DEBT_CHART_PLAN_COPY = "Your plan";
exports.DEBT_CHART_MINIMUMS_COPY = "Minimums only";
/** "Debt-free Dec 2028", the label at the end of the plan's line. */
function debtChartEndCopy(date) {
    return `Debt-free ${date}`;
}
/** The chart's `aria-label`: "Total debt falls from $39,130 to $0 by Dec 2028 with your
 *  plan, versus Jul 2030 with minimums only." */
function debtChartLabelCopy(total, debtFree, minimumsFree) {
    return `Total debt falls from ${total} to $0 by ${debtFree} with your plan, versus ${minimumsFree} with minimums only.`;
}
//# sourceMappingURL=debtEliminatorPageCopy.js.map